import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { ShareableLinkAnalyticsMemberEntry } from 'models/ShareableLink';
import SecureLinkMember from './components/SecureLinkMember';
import ContentLoader from 'react-content-loader';

import './SecureLinkMembers.styles.scss';

const RowPlaceholder = () => (
  <ContentLoader
    width="100%"
    height={40}
    backgroundColor="#e7f1fc"
    foregroundColor="#ffffff"
  >
    <rect x="0" y="0" rx="8" ry="8" width="100%" height="40" />
  </ContentLoader>
);

type SecureLinkMembersProps = {
  className?: string;
  isLoading?: boolean;
  members: ShareableLinkAnalyticsMemberEntry[];
};

const SecureLinkMembers: React.FC<SecureLinkMembersProps> = (props) => {
  const { className, isLoading, members = [] } = props;

  const classes = classNames('secure-link-members', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <p>{t('activityByUser')}</p>

      {isLoading
        ? Array(3)
            .fill(null)
            .map((_, i) => <RowPlaceholder key={i} />)
        : members.map((entry) => (
            <SecureLinkMember key={entry.member._id} entry={entry} />
          ))}
    </div>
  );
};

export default SecureLinkMembers;
